import gql from 'not-graphql-tag';
import {
  QueryValidateSerialNumberArgs,
  ValidateSerialNumberInput,
  ValidateSerialNumberOutput,
} from '../../__generated__/pgeplus-types';
import { useApolloClient } from '@apollo/react-hooks';
import { useState } from 'react';

export const validateSerialNumberQuery = gql`
  query ValidateSerialNumber($input: ValidateSerialNumberInput!) {
    validateSerialNumber(input: $input) {
      isEnrolled
    }
  }
`;

const useValidateSerialNumber = () => {
  const apolloClient = useApolloClient();
  const [isValidating, setIsValidating] = useState(false);

  const validateSerialNumber = async (
    input: ValidateSerialNumberInput,
  ): Promise<boolean> => {
    setIsValidating(true);

    try {
      const { data } = await apolloClient.query<
        { validateSerialNumber: ValidateSerialNumberOutput },
        QueryValidateSerialNumberArgs
      >({
        query: validateSerialNumberQuery,
        variables: { input },
        context: { pgePlus: true, installerPortal: true },
        fetchPolicy: 'network-only',
      });

      const isEnrolled = data?.validateSerialNumber?.isEnrolled;
      if (typeof isEnrolled !== 'boolean') {
        throw new Error('Invalid validateSerialNumber response');
      }
      return isEnrolled;
    } finally {
      setIsValidating(false);
    }
  };

  return {
    validateSerialNumber,
    isValidating,
  };
};

export default useValidateSerialNumber;
